export enum TwoFactorMethod {
  google = 'google',
  email = 'email',
  sms = 'sms',
  application = 'application',
}
